<div class="enlarge-image-options">
  <span class="image-close" (click)="closeModal()">
    ✕
  </span>
</div>

<div class="swiper mySwiper">
  <div class="swiper-wrapper">
    <ng-container *ngFor="let productImage of selectedQuoteProduct?.product?.sample_product?.sample_product_image">
      <div class="swiper-slide"
        *ngIf="productImage.type === Constants.PRODUCT_IMAGE || productImage.type === Constants.FORMAT_HERO_IMAGE">
        <div class="product-gallery-image">
          <img [src]="Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL + '/' + productImage.path" height="841" width="530"
            (error)="helperService.getErrorImage($event, 'no-image-round-border.svg')" loading="lazy"
            [alt]="getFileName(productImage.path)" [title]="getFileName(productImage.path)" />
        </div>
      </div>
    </ng-container>
  </div>
  <div class="swiper-pagination"></div>
  <div class="swiper-button-next product-next-image"></div>
  <div class="swiper-button-prev product-prev-image"></div>
</div>
